import theme from "../../../styles/theme";

const DrawProperties = ({
  label,
  value,
  onChange,
  placeholder = "",
  error = false,
  disabled = false,
  readOnlyMode = false,

  width = "100%",
  height = 28,
  labelWidth = 70,
  gap = 8,
  marginTop = 0,
  marginBottom = 0,
  padding = "2px 8px",

  type = "text", // "text" | "number"
  align = "left",

  style = {},
  inputStyle = {},
}) => {
  const isReadOnly = readOnlyMode || disabled;

  const displayValue =
    value === null || value === undefined
      ? ""
      : typeof value === "string" || typeof value === "number"
      ? String(value)
      : value?.label ?? value?.text ?? value?.name ?? value?.title ?? "";

  const handleChange = (e) => {
    if (isReadOnly || !onChange) return;

    const rawValue = e.target.value;

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      onChange({
        ...value,
        label: rawValue,
      });
      return;
    }

    if (type === "number") {
      if (rawValue === "") {
        onChange("");
        return;
      }

      const numericValue = Number(rawValue);

      if (!Number.isNaN(numericValue)) {
        onChange(numericValue);
      }
      return;
    }

    onChange(rawValue);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width,
        gap,
        marginTop,
        marginBottom,
        boxSizing: "border-box",
        ...style,
      }}
    >
      {label && (
        <label
          style={{
            width: labelWidth,
            minWidth: labelWidth,
            fontFamily: theme.form.label.fontFamily,
            fontSize: theme.form.label.fontSize,
            fontWeight: theme.form.label.fontWeight,
            color: theme.form.label.color,
            lineHeight: 1.2,
          }}
        >
          {label}
        </label>
      )}

      <input
        type={type === "number" ? "number" : "text"}
        value={displayValue}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={isReadOnly}
        style={{
          flex: 1,
          height,
          minHeight: height,
          padding,
          boxSizing: "border-box",
          fontFamily: theme.form.field.fontFamily,
          fontSize: theme.form.field.fontSize,
          fontWeight: theme.form.field.fontWeight,
          color: isReadOnly
            ? theme.colors.text.body
            : theme.form.field.color,
          borderRadius: isReadOnly ? 0 : theme.borders.radius.md,
          border: isReadOnly
            ? "none"
            : `1px solid ${error ? theme.colors.text.danger : theme.colors.borders.default}`,
          backgroundColor: isReadOnly
            ? "transparent"
            : theme.colors.background.input,
          outline: "none",
          textAlign: align,
          transition: theme.form.field.transition,
          WebkitAppearance: "none",
          MozAppearance: "textfield",
          ...inputStyle,
        }}
      />
    </div>
  );
};

export default DrawProperties;